module.exports = __webpack_public_path__ + "img/cz.8c3f3b2.svg";